
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_USERNAME_GET_DEVICE_REQUEST,
    CHANGE_USERNAME_GET_SIM_DETAILS_REQUEST,
    CHANGE_USERNAME_UPDATE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { changeUsernameUpdateResult } from 'Redux/actions';




function* changeUsername({ payload }) {
    try {
        let QUERY = `
            mutation changeUsername ($newUsername: String!, $entityId: Int!, $masterUser: Boolean!) {
                result: changeUsername (newUsername: $newUsername, entityId: $entityId, masterUser: $masterUser)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(changeUsernameUpdateResult({ update: data.result }))

    } catch (exc) {
        yield put(changeUsernameUpdateResult({ update: false, error: exc }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/changeUsername/redux/saga",
            "updateUnitSimCard",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_USERNAME_UPDATE_REQUEST, changeUsername);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}